import NextLink, { type LinkProps as NextLinkProps } from 'next/link';
import type { ComponentProps, PropsWithChildren } from 'react';
import { styled } from '@styled-system/jsx';

const StyledNextLink = styled(NextLink, {});

type AProps = ComponentProps<typeof StyledNextLink>;

export type LinkProps = PropsWithChildren<
  NextLinkProps &
    AProps & {
      // default: true
      useNextLink?: boolean;
    }
>;

export const Link = ({
  href,
  className,
  children,
  useNextLink,
  ...props
}: LinkProps) => {
  if (useNextLink === false) {
    return (
      <styled.a href={href.toString()} {...props} className={className}>
        {children}
      </styled.a>
    );
  }

  return (
    <StyledNextLink
      href={href}
      prefetch={false}
      {...props}
      className={className}
    >
      {children}
    </StyledNextLink>
  );
};
